//eventually refactor /editor/[slug].js to use this component

import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import LinkIcon from '../../Icons/link';
import TwitterImage from '../../TwitterImage';
var twitter = require('twitter-text');

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import { GlobeIcon } from '@heroicons/react/solid';

export default function MediumStoryPreview({
  mediumEditorText,
  headline,
  hasMedium,
  mediumProfile,
  inEditor = false,
}) {
  return (
    <>
      <div className="relative flex w-full max-w-lg flex-grow flex-col bg-white">
        <div className="flex flex-row items-center justify-start space-x-2">
          <img
            src={mediumProfile.imageUrl}
            className={'rounded-full'}
            width={32}
            height={32}
          />
          <div className="flex flex-col items-start justify-start space-y-0">
            <div className="flex flex-row items-center justify-start space-x-2">
              <p className="text-sm font-semibold text-gray-900">
                {mediumProfile.name}
              </p>
              <div className="hpver:bg-gray-600 cursor-pointer rounded-full bg-gray-500 px-2 py-0.5 text-xs font-medium text-white">
                Follow
              </div>
            </div>
            <div className="flex flex-row items-center justify-start space-x-2">
              <p className="text-xs text-gray-500">Just Now</p>
            </div>
          </div>
        </div>

        <div className="mt-4 mb-4 flex flex-col space-y-1">
          {headline ? (
            <p className=" font-sans text-2xl font-bold text-gray-900">
              {headline}
            </p>
          ) : (
            <p className=" font-sans text-2xl font-bold text-gray-400">
              Your headline will show here...
            </p>
          )}
        </div>

        <div class="prose medium">
          {mediumEditorText ? (
            <div dangerouslySetInnerHTML={{ __html: mediumEditorText }} />
          ) : (
            <p className="font-sans text-base text-gray-500">
              Your Medium story will show up here...
            </p>
          )}
        </div>
      </div>
    </>
  );
}
